require('components/layout')
require('components/gdpr_cookie_notice')
require('securities_landing_page/index')
require('components/dianomi')
require('components/lazy_load_images')